module.exports = __webpack_public_path__ + "static/media/bootstrap-landing-page-footer.b8646911.jpg";